module.exports = __webpack_public_path__ + "img/0-71.78f2f943.jpg";